<template>
  <div class="mainLongRing" ref="scrollable">
    <h1 class="title_text padding page-title">
      Расчет длины шинки
    </h1>
    <div class="headerBlock-select padding">
      <div class="switcherBox" style="gap: 12px;" v-if="isOwnSample">
        Впишите плотность г/см³
        <castom-input
          :defaultValue="0"
          style="width: 76px;"
          v-model="inputs.density"
          :required="isRequired"
          ref="resetDensity"
        />
      </div>
      <div class="switcherBox" style="gap: 10px;" v-if="!isOwnSample">
        Выберите пробу
        <castom-select
            :placeholder="'Проба'"
            :options="density"
            style="width: 80px;"
            v-model="inputs.density"
            :required="isRequired"
        />
      </div>
      <div class="switcherBox">
        Своя плотность
        <CastomSwitcher
            style="margin-bottom: 7px;"
            v-model="isOwnSample"
        />
      </div>
    </div>
    <div class="headerBlock-metal padding">
      <SelectMetal
          v-model="selectedMetal"
      />
    </div>
    <div class="sectionBlock padding">
      <div style="margin-bottom: 10px;">
        Выберите сечение
      </div>
      <SectionSelect
          style="width: 98%"
        v-model="selectedSection"
      />
    </div>
    <div class="mainLongRing-inputs padding">
      <div class="mainLongRing-inputs-thickness">
        <p>Ширина заготовки мм.</p>
        <castom-input
            fontSize="16px"
            v-model="inputs.width"
            ref="resetWidth"
            :required="isRequired"
        />
      </div>
      <div class="mainLongRing-inputs-thickness">
        <p>Толщина заготовки мм.</p>
        <castom-input
          fontSize="16px"
          v-model="inputs.height"
          ref="resetHeight"
          :required="isRequired"
        />
      </div>
      <div class="mainLongRing-inputs-thickness">
        <p>Размер кольца мм.</p>
        <castom-input
          fontSize="16px"
          v-model="inputs.size"
          ref="resetSize"
          :required="isRequired"
        />
      </div>
    </div>
    <button
        @click="calculateClick"
        class="button"
    >
      Рассчитать
    </button>
    <div class="footer flexColumn" v-if="longRing || weight">
      <div class="footer-container flexRow" v-if="longRing">
        <div class="footer-text fs14">
          Длинна заготовки
        </div>
        <div class="footer-number fs14">
          {{ longRing }}
        </div>
        <div class="footer-text fs14">
          мм
        </div>
      </div>
      <div class="footer-container flexRow" v-if="weight">
        <div class="footer-text fs14">
          Вес кольца
        </div>
        <div class="footer-number fs14">
          {{ weight }}
        </div>
        <div class="footer-text fs14">
          г
        </div>
      </div>
      <div class="footer-container flexRow" v-if="metalCost">
        <div class="footer-text fs14">
          Стоимость металла
        </div>
        <div class="footer-number fs14">
          {{ formatPrice(metalCost) }}
        </div>
        <div class="footer-text fs14">
          ₽
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CastomInput from '../../inputs/CastomInput'
import {computed, reactive, ref, watch} from "vue";
import SectionSelect from '../../selects/SectionSelect'
import SelectMetal from "@/components/selects/SelectMetal";
import CastomSelect from "@/components/selects/CastomSelect";
import metalDensity from "@/jsonData/metalDensity.json"
import CastomSwitcher from "@/components/switchers/CastomSwitcher"
import {setArea} from "../../../helpers/helpers"
import { useMetalsStore } from "@/stores/metalsPrice/metalsStore"
import { formatPrice } from "@/helpers/helpers"
import { trackCalculation } from '@/helpers/calculationAnalytics'

const selectedMetal = ref('silver')
const selectedSection = ref('Полукруг')
const isOwnSample = ref(false)
const resetSize = ref(null)
const resetWidth = ref(null)
const resetHeight = ref(null)
const resetDensity = ref(null)
const longRing = ref('')
const weight = ref('')
const isRequired = ref(false)

const scrollable = ref(null)
const metalsStore = useMetalsStore()

const inputs = reactive({
  height: 0,
  size: 0,
  width: 0,
  density: '',
})
if (window.gtag) {
  window.gtag('event', 'long-ring_calculator', {})
}
const density = computed(()=>{
  if(isOwnSample.value) {
    return {density: inputs.density.density, name: 'Своя'}
  } else {
    return selectedMetal.value ==='silver'? metalDensity.silver : metalDensity.gold
  }

})
const area = computed (() => {
  if(inputs.height && inputs.width) {
    return (setArea(selectedSection.value, inputs))/100
  } else {
    return 0
  }
})
const volume = computed(()=> {
  if(area.value && longRing.value) {
    return (area.value * (longRing.value/10))
  } else {
    return 0
  }

})

const assayValue = computed(() => {
  if (isOwnSample.value) return null
  return inputs.density?.value ? Number(inputs.density.value) : null
})

const metalRate = computed(() => {
  if (!metalsStore?.data) return 0
  return selectedMetal.value === 'gold'
    ? Number(metalsStore.data.gold || 0)
    : Number(metalsStore.data.silver || 0)
})

const metalCost = computed(() => {
  const w = Number(weight.value) || 0
  const rate = metalRate.value || 0
  const assay = assayValue.value
  if (!w || !rate || !assay) return null
  const cost = w * rate * (assay / 1000)
  return Number.isFinite(cost) ? cost.toFixed(2) : null
})
const calculateClick = () => {
  setTimeout(()=> {
    scrollToBottom()
  }, 500)
  isRequired.value = true
  if(inputs.size && inputs.height) {
    longRing.value =  ((inputs.size + inputs.height) * 3.14).toFixed(2)
  } else {
    longRing.value = 0
  }
  const volumeValue = volume.value
  const densityValue = !isOwnSample.value ? inputs.density.density : inputs.density
  if (volumeValue && densityValue) {
    weight.value = parseFloat((volumeValue * densityValue).toFixed(2))
  } else {
    weight.value = 0
  }
  if (Number(longRing.value) > 0 || Number(weight.value) > 0) {
    trackCalculation('long_ring')
  }
}
const scrollToBottom = () => {
  if (scrollable.value) {
    scrollable.value.scrollTo({
      top: scrollable.value.scrollHeight,
      behavior: 'smooth',
    });
  }
};
// const longRing = computed(()=> {
//
// })
// const weight = computed(() => {
//
// });

const resetValues = () => {
  longRing.value = 0
  weight.value = 0
  if (!inputs.height && resetHeight.value?.resetValue) resetHeight.value.resetValue()
  if (!inputs.size && resetSize.value?.resetValue) resetSize.value.resetValue()
  if (!inputs.width && resetWidth.value?.resetValue) resetWidth.value.resetValue()
}
watch((selectedMetal), () => {
  resetValues()
  if(!isOwnSample.value) {
    inputs.density = 0
  }
})
watch((isOwnSample), () => {
  inputs.density = 0
  resetValues()
})

</script>

<style lang="scss" scoped>
.mainLongRing {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  align-items: center;
  text-align: center;
  height: calc(100vh - 140px);;
  width: 100%;
  justify-content: flex-start;
  padding-bottom: 10px;
  &-inputs {
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: auto;
    color: white;
    gap: 25px;
    text-align: center;
    font-size: 14px;
    align-items: flex-end;
    padding-bottom: 10px;
    &-thickness{
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
    }
   }
}
.mainLongRing-inputs-thickness p {
  margin: 0 0 10px 0;
  min-height: 34px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.logo {
  text-align: center;
  &-image {
    height: 30vh;
    width: 30vh;
    filter: invert(100%) sepia(26%) saturate(1374%) hue-rotate(189deg) brightness(96%) contrast(91%);
  }
}
.footer {
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 25px;
  border: 2px solid #fff;
  height: auto;
  padding: 10px;
  width: 90%;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.25);
  background: linear-gradient(180deg, rgba(181, 162, 189, 0.33) 0%, rgba(26, 21, 28, 0.33) 100%);
  gap: 7px;
  &-container {
    color: white;
    justify-content: flex-start
  }
  &-text {
    font-size: 18px;
    font-weight: bold;
    margin-left: 10px;
  }
  &-number {
    font-size: 18px;
    font-weight: bold;
    margin-left: auto;
  }
}
.sectionBlock {
  margin-top: 34px;
  color: white;
  width: 100%;
  font-size: 16px;
  padding: 15px 0 35px 0 !important;
}
.headerBlock {
    &-select {
    width: 100%;
    justify-content: space-between;
    display: flex;
    //height: calc(100vh - 140px);
    align-items: center;
    padding-right: 20px;
    padding-left: 20px;
  }
  &-metal {
    width: 100%;
  }
}
.switcherBox {
  text-align: center;
  font-size: 14px;
  color: white;
  display: flex;
  flex-direction: column;
  gap: 19px;
  align-items: center;
}
.fs14 {
  font-size: 14px;
}
.padding {
  border: 2px solid white;
  border-left: none;
  border-right: none;
  border-bottom: none;
  padding: 10px 0;
}
.flexColumn {
  display: flex;
  flex-direction: column;
}
.flexRow {
  display: flex;
  flex-direction: row;
}
.title_text {
  color: white;
  width: 100%;
}
.button {
  background: rgba(0, 0, 0, 0.22);
  color: rgba(255, 255, 255, 0.98);
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.2px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  cursor: pointer;
  padding: 14px 20px;
  margin-top: 20px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: transform 0.08s ease, filter 0.18s ease;
  user-select: none;
}

.button:active {
  transform: translateY(1px) scale(0.99);
  filter: brightness(0.96);
}

.button:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.95);
  outline-offset: 2px;
}
</style>
